import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData, presentDate } from '../../../functionalComponents/dataFormatFunctions';
import jwt_decode from 'jwt-decode';

const useStyles = makeStyles((theme) => ({
  font: {
    fontWeight: 600,
    textAlign: 'initial',
    paddingBottom: '0.25rem',
    fontSize: '1rem',
  },
  fontPadding: {
    textAlign: 'initial',
    overflow: 'auto',
    paddingTop: '0.25rem',
    fontSize: '1rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  rowContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  ribbonContainer: {
    backgroundColor: '#c2e1ef',
    padding: '1rem',
    marginBottom: '1rem',
  },
  tableContainer: {
    boxShadow: "none",
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none",
    padding: "16px",
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none",
    padding: "16px",
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
}));

const ASLCheckDetails = (props) => {
  const classes = useStyles();
  const { batchDetails, grnNumber } = props;

  // Check if aslDataList exists and has data
  const aslDataList = batchDetails?.aslDataList || [];
  
  if (!aslDataList || aslDataList.length === 0) {
    return null;
  }

  // Get the first ASL record (assuming we only display the first one, similar to GenerateGRNDialog)
  const aslRecord = aslDataList[0];

  // Function to extract user information from auth token
  const getUserFromToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    
    try {
      const decoded = jwt_decode(token);
      return {
        fullName: decoded.full_name || decoded.fullName || 'N/A',
      };
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };
  

  // Get user information from token
  const userInfo = getUserFromToken();

  // Prepare display data for the ribbon table
  const displayData = {
    cmo: batchDetails?.cmoMember || batchDetails?.vendorName || 'N/A',
    cmoIdFromSponsorERP: batchDetails?.vendorNumber || 'N/A',
    plantId: batchDetails?.vendorPlant || 'N/A',
    poNumber: batchDetails?.scheduleAgreementNumber || batchDetails?.poNumber || 'N/A',
    productCode: batchDetails?.fgMaterialCode || batchDetails?.productCode || 'N/A',
    productDescription: batchDetails?.fgMaterialName || batchDetails?.productDescription || 'N/A',
    batchNumber: batchDetails?.vendorBatchNumber || batchDetails?.batchNumber || 'N/A',
    dateOfManufacturing: batchDetails?.manufacturingDate ? new Date(batchDetails.manufacturingDate).toLocaleDateString('en-GB') : 'N/A',
    productExpiryDate: batchDetails?.expiryDate ? new Date(batchDetails.expiryDate).toLocaleDateString('en-GB') : 'N/A',
    loggedInUser: userInfo?.fullName || 'N/A',
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      
      const day = date.getDate();
      const month = date.getMonth(); // 0-11
      const year = date.getFullYear();
      
      const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      
      return `${day}-${monthNames[month]}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Format date with time for timestamp display (dd-mon-yyyy HH:MM:SS)
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    try {
      const date = new Date(dateTimeString);
      if (isNaN(date.getTime())) return 'N/A';
      
      const day = String(date.getDate()).padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      return dateTimeString;
    }
  };


  const formatDateTimeLocal = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    try {
      let dateStr = dateTimeString;
      
   
      if (dateStr.includes('.')) {
        const match = dateStr.match(/^(.+?)\.(\d+)(.*)$/);
        if (match) {
          const [, timePart, decimalPart, timezonePart] = match;
          // Keep only first 3 digits for milliseconds, remove rest
          const milliseconds = decimalPart.substring(0, 3);
          dateStr = `${timePart}.${milliseconds}${timezonePart || ''}`;
        }
      }
      
      // If no timezone indicator (Z or +/-offset), treat as UTC by appending 'Z'
      if (!dateStr.endsWith('Z') && !dateStr.match(/[+-]\d{2}:\d{2}$/)) {
        dateStr = dateStr + 'Z';
      }
      
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return 'N/A';
      
      // Use local timezone methods (automatically converts UTC to user's system timezone)
      const day = String(date.getDate()).padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      return dateTimeString;
    }
  };

  return (
    <React.Fragment>
      
      {/* Blue Ribbon Header for ASL Details Section */}
      <Grid 
        container 
        justifyContent="flex-start"
        style={{ padding: '1rem', marginTop: '5px', marginBottom: '2px' }}
      >
        <Grid item xs={8} sm={12} md={12} className={classes.grid} style={{ marginLeft: '-10px' }}>
          <Typography variant='h4' className={classes.title}>
            ASL Check Details
          </Typography>
          <span className={classes.borders}></span>
        </Grid>
      </Grid>

      {/* Blue Ribbon Table with Batch Details */}
      <Grid
        container
        justifyContent="flex-start"
        style={{ backgroundColor: "#c2e1ef" }}
      >
        <Grid item>
          <TableContainer
            component={Paper}
            className={classes.tableContainer}
          >
            <Table className={classes.table} aria-label="batch details ribbon">
              <TableHead>
                <TableRow>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    CMO
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    CMO ID from Sponsor ERP
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Plant ID
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    PO Number
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Product Code / Description
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Batch Number
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Date of Manufacturing
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Product Expiry Date
                  </TableCell>
                  <TableCell className={`${classes.tableCell} ${classes.headerCell}`}>
                    Logged in user
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCell2}>
                    {displayData.cmo}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.cmoIdFromSponsorERP}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.plantId}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.poNumber}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.productCode} / {displayData.productDescription}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.batchNumber}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.dateOfManufacturing}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.productExpiryDate}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {displayData.loggedInUser}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>


      {/* ASL Details - 3 rows with 3 columns each */}
      <Grid container>
        <Grid container item xs={12} className={classes.rowContainer}>
          {grnNumber && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                GRN Number
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(grnNumber)}
              </Typography>
            </Grid>
          )}
          {aslRecord.manufacturer && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                ASL Number (Manufacturer)
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.manufacturer)}
              </Typography>
            </Grid>
          )}
          {aslRecord.mpnMaterial && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                MPN Number
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.mpnMaterial)}
              </Typography>
            </Grid>
          )}
          {aslRecord.name && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Name
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.name)}
              </Typography>
            </Grid>
          )}
          {aslRecord.street && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Street
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.street)}
              </Typography>
            </Grid>
          )}
          
        {/* </Grid> */}

        {/* <Grid container item xs={12} className={classes.rowContainer}> */}
          {aslRecord.cityPostalCode && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                City Postal Code
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.cityPostalCode)}
              </Typography>
            </Grid>
          )}
          {aslRecord.supplyChainStatus && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Supply Chain Status
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.supplyChainStatus)}
              </Typography>
            </Grid>
          )}
          {aslRecord.regionCountry && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Region Country
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(aslRecord.regionCountry)}
              </Typography>
            </Grid>
          )}
        {/* </Grid> */}

        {/* <Grid container item xs={12} className={classes.rowContainer}> */}
          
          {/* {aslRecord.validFrom && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Valid From
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {formatDate(aslRecord.validFrom)}
              </Typography>
            </Grid>
          )} */}
          {aslRecord.validTo && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Expiry Date
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {formatDate(aslRecord.validTo)}
              </Typography>
            </Grid>
          )}
          {aslRecord.lastUpdatedDate && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
               TimeStamp of ASL Submission in to SAP
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {formatDateTimeLocal(aslRecord.lastUpdatedDate)}
              </Typography>
            </Grid>
          )}
        {/* </Grid> */}

        {/* <Grid container item xs={12} className={classes.rowContainer}> */}
          {aslRecord.transactionID && (
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Transaction ID of ASL Submission in to SAP
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {aslRecord.transactionID}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <hr />
    </React.Fragment>
  );
};

export default ASLCheckDetails;

